export default "<div class=\"tab-content\" ng-transclude ng-if=\"!vm.isHidden\"></div> ";